import React from "react"
import ToolTip from "react-portal-tooltip"
import { grey800 } from "material-ui/styles/colors"
import { IDeviceDocument } from "../../../../models"
import * as api from "../../../../api"
import { CircularProgress } from "material-ui"
import strings from "../../../../localization/strings"
import DevicePermissionsInfo from "../../../device/DevicePermissionsInfo"
interface IProps {
    deviceId: string
}
interface IState {
    open: boolean
    loadingDevice: boolean
    device: IDeviceDocument
}

export default class ExceptionBodyDeviceInfo extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            loadingDevice: false,
            device: null
        }
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.props.deviceId !== nextProps.deviceId &&
            this.setState({
                open: false,
                loadingDevice: false,
                device: null
            })
    }

    getDeviceInfo() {
        this.state.open && this.props.deviceId && !this.state.device &&
            this.setState({ loadingDevice: true }, () =>
                api.getDevice(this.props.deviceId).then(res =>
                    this.setState({
                        loadingDevice: false,
                        device: res.data
                    })
                )
            )
    }

    render() {
        const { device } = this.state
        return (
            <div>
                <ToolTip
                    active={this.state.open}
                    position="right"
                    arrow="top"
                    parent={"#" + "exception-body-device-info-" + this.props.deviceId}
                    tooltipTimeout={50}
                >
                    <div
                        className={this.state.loadingDevice && "spinner"}
                        style={{ width: 350, padding: 10, fontSize: 16, color: grey800 }}
                    >
                        {this.state.loadingDevice ?
                            <CircularProgress /> :
                            device &&
                            <div>
                                <div>
                                    <b style={{ marginRight: 15 }}>{strings.Name}:</b>
                                    <span style={{ marginRight: 5 }}>{device.Name}</span>
                                </div>
                                <div>
                                    <b style={{ marginRight: 15 }}>{strings.Registration_Code}:</b>
                                    <span style={{ marginRight: 5 }}>{device.RegistrationCode}</span>
                                </div>
                                <div>
                                    <b style={{ marginRight: 15 }}>{strings.Description}:</b>
                                    <span style={{ marginRight: 5 }}>{device.Description || ""}</span>
                                </div>
                                <div>
                                    <b style={{ marginRight: 15 }}>{strings.os}:</b>
                                    <span style={{ marginRight: 5 }}>{device.CurrentStatus && device.CurrentStatus.OS == 0 && "iOS" || device.CurrentStatus && device.CurrentStatus.OS == 1 && "Android"}</span>
                                </div>
                                <div>
                                    <b style={{ marginRight: 15 }}>{strings.Device_Mode}:</b>
                                    <span style={{ marginRight: 5 }}>{device.UserId ? strings.Individual_Mode : device.IsMobileClock ? strings.MobileClockMode : strings.Clock_Mode}</span>
                                </div>
                                <div>
                                    <b style={{ marginRight: 15 }}>{strings.Connection_Type}:</b>
                                    <span style={{ marginRight: 5 }}>{device.CurrentStatus && device.CurrentStatus.WiFi && 'WiFi' || device.CurrentStatus && device.CurrentStatus.Cellular && 'Cellular'}</span>
                                </div>
                                <div>
                                    <b style={{ marginRight: 15 }}>{strings.App_Version}:</b>
                                    <span style={{ marginRight: 5 }}>{device.CurrentStatus && device.CurrentStatus.AppVersion}</span>
                                </div>
                                <div style={{ marginTop: 10 }}>
                                    <DevicePermissionsInfo
                                        devicePermissions={device.CurrentStatus ? device.CurrentStatus.DevicePermissions : null}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </ToolTip>
                <i
                    id={"exception-body-device-info-" + this.props.deviceId}
                    className="fa fa-info-circle"
                    style={{ color: grey800, cursor: "pointer", fontSize: 15 }}
                    onClick={() => this.setState({ open: !this.state.open }, () => this.getDeviceInfo())}
                    onMouseOut={() => this.setState({ open: false })}
                />
            </div>
        )
    }
}